/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DestinationProviderAttributesAzure } from '../models/DestinationProviderAttributesAzure';

export class DestinationProviderAttributes {
  'azure'?: DestinationProviderAttributesAzure | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "azure",
      "baseName": "azure",
      "type": "DestinationProviderAttributesAzure",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DestinationProviderAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}

